import { ArrowRight, FileCheck2 } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';

export function LandingPage() {
  return (
    <section className="page">
      <PageHeader
        eyebrow="AI agent orchestration harness"
        title="Rank the right agents, tools, evidence, and workflows for every LLM task."
        description="Design reusable score sheets that separate human approvals from agent execution and prepare MCP-compatible outputs."
        actions={
          <>
            <button className="button" type="button">
              <ArrowRight size={16} aria-hidden="true" />
              Open dashboard
            </button>
            <button className="button secondary" type="button">
              <FileCheck2 size={16} aria-hidden="true" />
              View contract
            </button>
          </>
        }
      />
      <div className="grid cols-3">
        {['Score agents', 'Verify evidence', 'Export workflows'].map((item) => (
          <article className="card" key={item}>
            <h2 className="section-title">{item}</h2>
            <p className="muted">Reusable templates, clear risk levels, and auditable decisions for production agent work.</p>
          </article>
        ))}
      </div>
    </section>
  );
}
